import api from "@/lib/axios";

export const noteTemplateService = {
  getAllTemplates: async (params = {}) => {
    try {
      const response = await api.get("/note-templates", { params });
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch note templates: " + error.message);
    }
  },

  createTemplate: async (templateData) => {
    try {
      const response = await api.post("/note-templates", templateData);
      return response.data;
    } catch (error) {
      throw new Error("Failed to create note template: " + error.message);
    }
  },

  updateTemplate: async (templateId, templateData) => {
    try {
      const response = await api.put(`/note-templates/${templateId}`, templateData);
      return response.data;
    } catch (error) {
      throw new Error("Failed to update note template: " + error.message);
    }
  },

  deleteTemplate: async (templateId) => {
    try {
      const response = await api.delete(`/note-templates/${templateId}`);
      return response.data;
    } catch (error) {
      throw new Error("Failed to delete note template: " + error.message);
    }
  },
};
